module.exports = __webpack_public_path__ + "static/headerBg-min-d9455df730aef7370de6e5423eb8b1d9.png";